<template>
	<v-container>
		<!--Envíos a domicilio -->
		<v-row>
	  	<v-col cols="12" >
	  		<v-card align="center" class="primary--text elevation-0 transparent">
	  			<v-card-title primary-title class="display-1">
	  			  No salgas de tu casa, recibe tu pedido hasta la puerta de tu casa
	  			</v-card-title>
	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" lx="3" lg="3" md="6" sm="6">
	  		<v-card height="100%" align="center" justify="center" class="elevation-0">
	  			<v-img  :src="url + 'fotos/USUARIO.png'" contain aspect-ratio="2" width="100%"/>
	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" lx="3" lg="3" md="6" sm="6">
	  		<v-card height="100%" align="center" justify="center" class="elevation-0">
	  			<v-img  :src="url + 'fotos/ARTICULOS.png'" contain aspect-ratio="2" width="100%"/>
	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" lx="3" lg="3" md="6" sm="6">
	  		<v-card height="100%" align="center" justify="center" class="elevation-0">
	  			<v-img  :src="url + 'fotos/ENVIO.png'" contain aspect-ratio="2" width="100%"/>
	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" lx="3" lg="3" md="6" sm="6">
	  		<v-card height="100%" align="center" justify="center" class="elevation-0">
	  			<v-img  :src="url + 'fotos/PEDIDO.png'" contain aspect-ratio="2" width="100%"/>
	  		</v-card>
	  	</v-col>
	  </v-row>

	 <!--  <v-row>
	  	<v-col cols="12" md="6">
	  		<v-card class="primary--text">
	  			<v-card-title primary-title>
	  			  Envíos <v-icon right large color="primary">local_shipping</v-icon>
	  			</v-card-title>
	  		  <ol>
	  		  	<li>biun</li>
	  		  </ol>
	  		</v-card>
	  	</v-col>
	  </v-row> -->


	  <v-row>
	  	<v-col cols="12" lx="4" lg="4" md="6" sm="6">
	  		<v-card align="center" class="elevation-0">
	  			<v-card-title primary-title class="primary--text">
	  			  Pagos mediante paypal
	  			</v-card-title>
	  		  <v-img  src="https://i.blogs.es/1332df/paypal-784404_960_720/450_1000.png" 
	  		  contain
	  		  width="100%"/>
	  		</v-card>
	  	</v-col>
	  </v-row>
	</v-container>
</template>
<script>
	export default{
		data(){
			return{
				url: this.$http.options.root,
			}
		}
	}
</script>